import {
  formatSupplierValidationDate,
  isSameCompanySupplier,
  isValidationExpired,
  resolveSupplierTransmissionType,
  toEmailValidationStatus,
} from 'src/services/manage_suppliers/supplierFilterItemMappers';
import { ManageSupplier } from 'src/types/manage-suppliers/ManageSupplier';
import {
  ManageSupplierEditContext,
  SupplierFormValues,
} from 'src/types/manage-suppliers/SupplierForm';
import { toSupplierFieldValue, toSupplierPhoneValue } from './supplierFormValues';

export const enrichSupplierForEdit = (supplier: ManageSupplier): ManageSupplierEditContext => {
  const isSameCompany = isSameCompanySupplier(supplier);
  const originalApId = toSupplierFieldValue(supplier.managementApId);
  const originalExternalSupplierName = toSupplierFieldValue(
    supplier.managementExternalSupplierName
  );

  return {
    ...supplier,
    address1: supplier.addressLine1 || supplier.address || '',
    address2: supplier.addressLine2 || '',
    transmissionType: resolveSupplierTransmissionType(supplier),
    ownedByCompanyName: supplier.createdBy,
    isSameCompany,
    originalExternalSupplierName,
    originalApId,
    emailValidationStatus: toEmailValidationStatus(supplier),
    emailValidationDateTime: formatSupplierValidationDate(supplier.validationStatusDate),
    emailValidationExpired: isValidationExpired(supplier),
  };
};

export const mapSupplierToFormValues = (supplier: ManageSupplierEditContext): SupplierFormValues => ({
  supplierName: toSupplierFieldValue(supplier.supplierName),
  status: supplier.status,
  externalSupplierName: toSupplierFieldValue(supplier.externalSupplierName),
  apId: toSupplierFieldValue(supplier.apId),
  accountNumber: toSupplierFieldValue(supplier.accountNumber),
  address1: toSupplierFieldValue(supplier.address1),
  address2: toSupplierFieldValue(supplier.address2),
  city: toSupplierFieldValue(supplier.city),
  stateProvince: toSupplierFieldValue(supplier.stateProvince),
  zipPostalCode: toSupplierFieldValue(supplier.zipPostalCode),
  country: toSupplierFieldValue(supplier.country),
  contactName: toSupplierFieldValue(supplier.contactName),
  phone: toSupplierPhoneValue(supplier.phone),
  orderEmail: toSupplierFieldValue(supplier.email),
  transmissionType: supplier.transmissionType,
});
